import { footer } from '../../components/layout/footer';
import { header } from '../../components/layout/header';
import { $, requireElement } from '../../lib/dom';
import { getCurrentPath } from '../router/router-state';
import { initThemeSwitcherButtons } from '../theme/theme-switcher';
import { markActiveNavigation } from './active-link';
import { initDrawer } from './drawer';
import { initDropdowns } from './dropdowns';

const SCROLLED_OFFSET_PX = 8;

function updateHeaderShadow(): void {
  $('header.nav')?.classList.toggle('scrolled', window.scrollY > SCROLLED_OFFSET_PX);
}

let scrollListenerBound = false;

/** Renders the header and footer (they depend on the active theme) and binds their behaviour. */
export function renderChrome(): void {
  const themerVisible = $('#themer')?.classList.contains('show') ?? false;
  requireElement('#chrome-top').innerHTML = header();
  requireElement('#chrome-bottom').innerHTML = footer();
  initDropdowns();
  initDrawer();
  if (!scrollListenerBound) {
    scrollListenerBound = true;
    window.addEventListener('scroll', updateHeaderShadow, { passive: true });
  }
  updateHeaderShadow();
  initThemeSwitcherButtons();
  if (themerVisible) $('#themer')?.classList.add('show');
  const path = getCurrentPath();
  if (path) markActiveNavigation(path);
}
